
class ShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('button.video-play-button').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.querySelector('video')
        this.playVideo(video)
      })
    })

    this.initializeVideoProgressBars()
    this.pauseVideosOnScroll()
  }

  initializeVideoProgressBars () {
    this.querySelectorAll('video').forEach(video => {
      const card = video.closest('.shoppable-videos-card')
      const progressBar = card.querySelector('.shoppable-videos-card-progress-bar')
      
      if (!progressBar) return

      // Update progress bar as video plays
      video.addEventListener('timeupdate', () => {
        if (video.duration) {
          const progress = (video.currentTime / video.duration) * 100
          progressBar.style.width = `${progress}%`
        }
      })

      // Reset progress bar when video ends
      video.addEventListener('ended', () => {
        progressBar.style.width = '0%'
        video.currentTime = 0
      })

      // Initialize progress bar when metadata loads
      video.addEventListener('loadedmetadata', () => {
        if (video.currentTime > 0 && video.duration) {
          const progress = (video.currentTime / video.duration) * 100
          progressBar.style.width = `${progress}%`
        }
      })
    })
  }

  playVideo (video) {
    // Pause other videos and reset them to beginning
    this.querySelectorAll('video').forEach(elem => {
      if (elem.dataset.index !== video.dataset.index) {
        elem.closest('.shoppable-videos-card').setAttribute('data-playing', 'false')
        elem.pause()
        elem.currentTime = 0
      }
    })

    const card = video.closest('.shoppable-videos-card')

    if (card.dataset.playing === 'true') {
      // Same video clicked - toggle play/pause
      card.setAttribute('data-playing', 'false')
      video.pause()
      video.blur()
    } else {
      // Start playing video
      card.setAttribute('data-playing', 'true')
      video.muted = false
      video.play()
      video.focus()
    }
  }

  pauseAllVideos () {
    this.querySelectorAll('video').forEach(video => {
      if (video.closest('.shoppable-videos-card').dataset.playing === 'true') {
        video.closest('.shoppable-videos-card').setAttribute('data-playing', 'false')
        video.pause()
        video.currentTime = 0
      }
    })
  }

  pauseVideosOnScroll () {
    this.querySelector('.carousel-track').addEventListener('scroll', () => {
      this.pauseAllVideos()
    })
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pauseAllVideos()
        }
      })
    }, { threshold: 0.25 })

    observer.observe(this)
  }
}
customElements.define('shoppable-videos', ShoppableVideos)